import * as React from 'react'
import {
  SortingState,
  PagingState,
  CustomPaging,
  TableColumnWidthInfo,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  Table,
  TableHeaderRow,
  PagingPanel,
  TableColumnResizing,
} from '@devexpress/dx-react-grid-material-ui'
import { Column, Row, PageSize } from '../../interfaces/components/table'
import { Ordering } from '../../interfaces/pages/projects'
import DI from '../../app/di'
import { Paper } from '@design/pt-ui'
import './style.css'

interface IProps {
  rows: Row[]
  columns: Column[]

  page: number
  pageSize: PageSize
  ordering: Ordering
  totalRows: number

  onCurrentPageChange: (page: number) => any
  onPageSizeChange: (pageSize: PageSize) => any
  onSortingChange: (order: Ordering) => any
}

const messages = {
  de: {
    tableMessages: {
      noData: 'Keine Daten verfügbar',
    },

    editColumnMessages: {
      addCommand: 'Neue Zeile',
      editCommand: 'Bearbeiten',
      deleteCommand: 'Entfernen',
      commitCommand: 'Speichern',
      cancelCommand: 'Abbrechen',
    },

    groupingPanelMessages: {
      groupByColumn: 'Ziehen Sie eine Spalte hierhin, um danach zu gruppieren',
    },

    filterRowMessages: {
      filterPlaceholder: 'Filter...',
    },

    pagingPanelMessages: {
      showAll: 'Alle',
      rowsPerPage: 'Projekte pro Seite',
      info: (params: { from: number; to: number; count: number }) =>
        `Projekte ${params.from} bis ${params.to} (${params.count} Projekte)`,
    },
  },
  en: {
    tableMessages: undefined,
    editColumnMessages: undefined,
    groupingPanelMessages: undefined,
    filterRowMessages: undefined,
    pagingPanelMessages: undefined,
  },
}

interface IState {
  columnWidths: TableColumnWidthInfo[]
  sortingStateColumnExtensions: SortingState.ColumnExtension[]
}

function GridTable(props: IProps) {
  const [state, setState] = React.useState<IState>({
    columnWidths: props.columns.map((column) => {
      return { columnName: column.name, width: 250 }
    }),
    sortingStateColumnExtensions: [
      { columnName: 'action', sortingEnabled: false },
    ],
  })

  const PagingContainer = (props: any) => (
    <PagingPanel.Container {...props} className="pagingContainer" />
  )

  const changeColumnWidths = (columnWidths: TableColumnWidthInfo[]) => {
    setState((state) => ({ ...state, columnWidths }))
  }

  const onPageSizeChange = (pageSize: number) => {
    props.onPageSizeChange(pageSize as PageSize)
  }

  const onCurrentPageChange = (pageNo: number) => {
    props.onCurrentPageChange(pageNo + 1)
  }

  const onSortingChange = (ordering: Ordering[]) => {
    props.onSortingChange(ordering[0])
  }

  const { rows, columns } = props
  const locale = DI.get('locale') as 'en' | 'de'

  return (
    <Paper>
      <Grid rows={rows} columns={columns}>
        <SortingState
          sorting={[props.ordering]}
          onSortingChange={onSortingChange}
          columnExtensions={state.sortingStateColumnExtensions}
        />
        <PagingState
          currentPage={props.page - 1}
          onCurrentPageChange={onCurrentPageChange}
          pageSize={props.pageSize}
          onPageSizeChange={onPageSizeChange}
        />
        <CustomPaging totalCount={props.totalRows} />
        <Table messages={messages[locale].tableMessages} />
        <TableColumnResizing
          columnWidths={state.columnWidths}
          onColumnWidthsChange={changeColumnWidths}
        />
        <TableHeaderRow showSortingControls={true} />
        <PagingPanel
          pageSizes={[5, 10, 20, 50, 100]}
          messages={messages[locale].pagingPanelMessages}
          containerComponent={PagingContainer}
        />
      </Grid>
    </Paper>
  )
}

export default GridTable
